/** @format */

import React from 'react';
import { Col, Row } from 'antd';
import { Address } from '../types';

interface AddressFormProps {
  address: Address;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const AddressForm: React.FC<AddressFormProps> = ({ address, onChange }) => {
  return (
    <Row gutter={[24, 24]}>
      <Col sm={24} md={24} lg={24} xl={24}>
        <div className='form-heading'>
          <span> Address *</span>
        </div>
      </Col>

      <Col sm={24} md={12} lg={12} xl={12}>
        <div className='form-input-wrapper'>
          <label style={{ marginBottom: '10px' }}>Street Address *</label>
          <input
            type='text'
            name='address.street'
            value={address.street}
            onChange={onChange}
            required
          />
        </div>
      </Col>

      <Col sm={24} md={12} lg={12} xl={12}>
        <div className='form-input-wrapper'>
          <label style={{ marginBottom: '10px' }}>Apt/Unit</label>
          <input
            type='text'
            name='address.aptUnite'
            value={address.aptUnite}
            onChange={onChange}
          />
        </div>
      </Col>

      <Col sm={24} md={12} lg={12} xl={12}>
        <div className='form-input-wrapper'>
          <label>City *</label>
          <input type='text' name='address.city' value={address.city} onChange={onChange} required />
        </div>
      </Col>

      <Col sm={24} md={12} lg={12} xl={12}>
        <div className='form-input-wrapper'>
          <label>State *</label>
          <input type='text' name='address.state' value={address.state} onChange={onChange} required />
        </div>
      </Col>

      <Col sm={24} md={12} lg={12} xl={12}>
        <div className='form-input-wrapper'>
          <label>Zip Code *</label>
          <input
            type='text'
            name='address.zipCode'
            value={address.zipCode }
            onChange={onChange}
            required
          />
        </div>
      </Col>
    </Row>
  );
};
